function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo } from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { Table } from '../table';
import { usePage } from './hooks/usePage';
import { useSort } from './hooks/useSort';
import { useFilter } from './hooks/useFilter';
export var DEFAULT_PAGE_SIZE = 10;
export var validCheck = function validCheck(target) {
  return Array.isArray(target) && target.length > 0;
};
export var SortTable = function SortTable(props) {
  var datasource = props.datasource,
      columns = props.columns,
      sorter = props.sorter,
      filters = props.filters,
      _props$pager = props.pager,
      pager = _props$pager === void 0 ? {} : _props$pager,
      onChange = props.onChange,
      extra = _objectWithoutProperties(props, ["datasource", "columns", "sorter", "filters", "pager", "onChange"]);

  var onChangeCallback = useRefCallback(onChange);

  var _useFilter = useFilter({
    filters: filters,
    columns: columns,
    datasource: datasource
  }),
      filteredDts = _useFilter.filteredDts,
      currentFilter = _useFilter.currentFilter,
      setCurrentFilter = _useFilter.setCurrentFilter;

  var _useSort = useSort({
    sorter: sorter,
    columns: columns,
    datasource: filteredDts
  }),
      sortedDts = _useSort.sortedDts,
      currentSorter = _useSort.currentSorter,
      setCurrentSorter = _useSort.setCurrentSorter;

  var _usePage = usePage({
    pager: pager,
    sortedDts: sortedDts
  }),
      currentDts = _usePage.currentDts,
      currentPage = _usePage.currentPage,
      setCurrentPage = _usePage.setCurrentPage;

  var autoPager = useMemo(function () {
    if (pager === false || currentPage === false) {
      return false;
    }

    var page = pager.page,
        defaultPage = pager.defaultPage,
        total = pager.total,
        _pager$pageSize = pager.pageSize,
        pageSize = _pager$pageSize === void 0 ? DEFAULT_PAGE_SIZE : _pager$pageSize,
        extra = _objectWithoutProperties(pager, ["page", "defaultPage", "total", "pageSize"]);

    if (total && page) {
      total > sortedDts.length && sortedDts.length > pageSize && console.warn('total is controlled and datasource.length < total, make sure async data usage correctly');
    }

    return _objectSpread({
      page: currentPage,
      pageSize: pageSize,
      total: total !== null && total !== void 0 ? total : sortedDts.length
    }, extra);
  }, [pager, sortedDts.length, currentPage]);
  var changeHandle = useCallback(function (tableState) {
    var page = tableState.page,
        sorterState = tableState.sorter,
        filtersState = tableState.filters;
    onChangeCallback(tableState);

    if (pager && pager.page == null) {
      setCurrentPage(page);
    }

    if (!sorter) {
      setCurrentSorter(sorterState);
    }

    if (!filters) {
      setCurrentFilter(filtersState);
    }
  }, [pager, sorter, filters, sortedDts]);
  return React.createElement(Table, Object.assign({}, extra, {
    datasource: currentDts,
    sorter: currentSorter,
    onChange: changeHandle,
    columns: columns,
    pager: autoPager,
    filters: currentFilter
  }));
};